import { useQuery } from '@apollo/client';
import { profile } from 'console';
import React from 'react';
import styled from 'styled-components';
import useSWR from 'swr';

import GraphQLErrorText from '../../components/GraphQLErrorText';
import Loading from '../../components/Loading';
import TidalDashboardHeader from '../../components/tidal-dashboard/common/header';
import TidalDashboardProfileCard from '../../components/tidal-dashboard/profile/TidalDashboardProfileCard';
import TidalDashboardProfileTranscriptsTable from '../../components/tidal-dashboard/profile/TidalDashboardProfileTranscriptsTable';
import TidalDashboardUpdateCard from '../../components/tidal-dashboard/profile/TidalDashboardUpdateCard';
import useAuthOrRedirect from '../../hooks/useAuthOrRedirect';
import { PROFILE } from '../../lib/graphql/queries';
import { NextSeo } from 'next-seo';

const TidalDashboardProfileWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const TidalDashboardProfileRow = styled.div`
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  @media only screen and (max-width: 1340px) {
    grid-template-columns: 1fr;
  }
  margin-top: 31px;
  grid-gap: 0 25px;
`;

const TidalDashboardUpdatesWrapper = styled.div`
  padding-left: 25px;
  border-left: 1px solid ${(props) => props.theme.colors.borderColors[0]};
  .tidal-dashboard-update-wrapper-sticky-list {
    flex-grow: 1;
    flex-basis: 300px;
    align-self: start;
    top: 60px;
    position: sticky;
    & > .heading {
      font-weight: 700;

      font-size: 21px;
      line-height: 25px;
      color: ${(props) => props.theme.colors.text[1]};
    }

    & > .description {
      margin-bottom: 25px;
      font-weight: 600;
      font-size: 14px;
      line-height: 17px;
      color: ${(props) => props.theme.colors.text[0]};
    }
  }
  @media only screen and (max-width: 1340px) {
    padding-left: 0;
    border-left: 0;
    margin-top: 32px;
  }
`;

const TidalDashboardProfileTranscriptTableRow = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: 0 25px;
  margin: 35px 0px;
  max-width: 100%;
  @media only screen and (max-width: 786px) {
    grid-gap: 8px 0;
  }
`;

const TidalDashboardProfile = (): JSX.Element => {
  const { loading, error } = useQuery(PROFILE);
  const {
    data,
    error: err,
    isValidating,
    mutate,
  } = useSWR('/dashboard/profile');

  if (!useAuthOrRedirect()) return null;

  if (loading || (!err && !data)) return <Loading />;

  if (error) return <GraphQLErrorText error={error} />;

  return (
    <TidalDashboardProfileWrapper>
      <NextSeo
        title={'Tidal Member Dashboard'}
        description={'Management dashboard for Tidal Marketplace memberships'}
      />
      <TidalDashboardHeader title="Profile" showSettings={false} tags={[]} />
      <TidalDashboardProfileRow>
        <div>
          <TidalDashboardProfileCard
            name={data?.nickname?.split('#')[0]}
            tag={data?.nickname?.split('#')[1]}
            memberSince={data?.joinedAt || null}
            reputation={data?.userReputation}
            isSubscriptionActive={data?.isSubscriptionActive}
            all={data?.totals?.all}
            userRoles={data?.userRoles}
            image={data?.avatar}
            discordConnection={data?.discordConnectionId}
            subscriptionStartDate={data?.subscriptionStartDate}
            subscriptionEndDate={data?.subscriptionEndDate}
            onRolesRefreshed={() => {
              mutate(data);
            }}
          />
          <TidalDashboardProfileTranscriptTableRow>
            <TidalDashboardProfileTranscriptsTable
              label="Transcripts"
              columns={['Bot', 'Amount', 'Party', 'Date', 'Actions']}
              data={data?.tickets}
            />
          </TidalDashboardProfileTranscriptTableRow>
        </div>
        <TidalDashboardUpdatesWrapper>
          <div className="tidal-dashboard-update-wrapper-sticky-list">
            <p className="heading">Tidal Updates</p>
            <p className="description">
              View the latest news from the Tidal team
            </p>
            <TidalDashboardUpdateCard
              image="/images/calendar.png"
              title="Rentals have never been easier!"
              description="Our new calendar makes purchasing a rental less clicks then ever, try it out and give us feedback so we can continue to make it better for you.."
              isNew={true}
            />
            <TidalDashboardUpdateCard
              image="/images/snapshots.png"
              title="Server snapshots are here!"
              description="Download your frameworks and bots to the server prior to snapshotting and they will be ready for you when servers are launched on drop day."
              isNew={false}
            />
            {/* <TidalDashboardUpdateCard
              image="/images/new_dash.png"
              title="Our new dash is here!"
              description="Scroll around and see all of our features now at your hand for zero cost!

              If you have any questions, check out our new support option in the bottom right hand of your window!"
              isNew={false}
            /> */}
            {/* <TidalDashboardUpdateCard
              image="https://cdn.discordapp.com/attachments/984843568751476796/985911543893987428/Screen_Shot_2022-06-13_at_19.50.20.png"
              title="Tidal Update"
              description="2 drops in 2 days and we have all the essential bots that you need to take stock!

            If the wave runners are the pair of Yeezys you need then get prepared with a rental from Tidal!"
              action="View rentals"
              isNew={false}
            />
            <TidalDashboardUpdateCard
              image="https://cdn.discordapp.com/attachments/984843568751476796/985911543893987428/Screen_Shot_2022-06-13_at_19.50.20.png"
              title="Tidal Update"
              description="2 drops in 2 days and we have all the essential bots that you need to take stock!

            If the wave runners are the pair of Yeezys you need then get prepared with a rental from Tidal!"
              action="View rentals"
              isNew={false}
            /> */}
          </div>
        </TidalDashboardUpdatesWrapper>
      </TidalDashboardProfileRow>
    </TidalDashboardProfileWrapper>
  );
};

export default TidalDashboardProfile;
